import React from 'react'
import { Responsive, WidthProvider } from 'react-grid-layout'
import { arrayOf, bool, func, instanceOf, object } from 'prop-types'
import Portlet from './Portlet'
import { Widget } from './Widget'
import { translate } from 'react-i18next'
import css from './DashboardBody.css'

const ResponsiveReactGridLayout = WidthProvider(Responsive);

class DashboardBody extends React.PureComponent {
  static propTypes = {
    widgets: arrayOf(instanceOf(Widget)),
    layouts: object,
    onLayoutChange: func,
    onWidgetRemove: func,
    editing: bool,
    filter: object
  };

  static defaultProps = {
    widgets: [],
    layouts: {},
    onWidgetRemove: () => { },
    onLayoutChange: () => { },
    editing: false
  };
  static makePortletFromWidget = t => (definition, editing, onWidgetRemove, onSave, filter) => {
    let Type = definition.type;
    if (definition.type.selfContained) {
      return <Type
        onRemove={onWidgetRemove}
        filter={filter}
        editing={editing} />;
    }
    let infoKey = Type.info || definition.info
    let infoText = t(Portlet.Header.LocalizeInfoKey(infoKey))
    let headerKey = Type.header || definition.name;
    let headerText = t(Portlet.Header.LocalizeHeaderKey(headerKey));
    return <Portlet
      onRemove={onWidgetRemove}
      editing={editing}
      info={infoText}
      header={headerText}>
      <Type
        filter={filter}
        editing={editing}
        onRemove={onWidgetRemove}
        saveEdits={onSave}
        header={headerText} />
    </Portlet>;
  };

  render() {
    let { onWidgetRemove, onSave, layouts, onLayoutChange, editing, filter, widgets, t } = this.props;
    let myWidgets = widgets.map((Widget, i) => {
      let gridProps = {
        x: 0,
        y: 10000,
        h: 2,
        w: 2,
        minW: 2,
        minH: 2,
        ...Widget.gridProps
      };
      let render = DashboardBody.makePortletFromWidget(t)(Widget.definition, editing, () => onWidgetRemove(Widget, i), onSave, filter);
      //Layout will id by the widgets id, keeping layout and widget ids in sync.
      return (
        <div key={Widget.id} data-grid={gridProps}>
          {render}
        </div>
      )
    });
    return (
        <ResponsiveReactGridLayout
          key="grid"
          className={css.dashBody}
          cols={{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }}
          rowHeight={30}
          layouts={layouts}
          onLayoutChange={onLayoutChange}
          isDraggable={editing}
          isResizable={editing}
        >
          {myWidgets}
        </ResponsiveReactGridLayout>
    );
  }
}

export default translate()(DashboardBody);
export {DashboardBody};
